module.exports = __webpack_public_path__ + "img/icon_service.b8067893.svg";